import React, { useState } from 'react';
import { useTranslation } from "react-i18next";

import { exportMembers } from "../services/users";

export const ExportUsersDialog = ({ children }) => {
  const [errors, setErrors] = useState([]);
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);

  const { t } = useTranslation();

  const open = () => {
    setShow(true)
  }

  const confirmExport = async (fromTeam) => {
    setLoading(true)

    try {
      await exportMembers();
      close(true)
    } catch (e) {
      if (e?.response?.data?.errors) setErrors(e?.response?.data?.errors)
    }
    setLoading(false)
  }

  const close = () => {
    setShow(false);
  }

  return (
    <>
      <span onClick={open}>{children || <button className="button button-add"><span className="icon icon-cloud-download"></span> {t('buttons.common.export-members')}</button>}</span>
      { show && 
        <div className="dialog">
          <div className="dialog-content">
            <div className="form-group">
              <label htmlFor="groupName">{t('buttons.common.export-members')}</label>
            </div>
            <div className="dialog-content-description">
              {t('common.export_notice')}
            </div>
            <div className="form-container-actions">
              <div className="flex-end form-actions">
                <button className="button" onClick={() => close()} disabled={loading}>
                  {t('buttons.common.cancel')}
                </button>
                <button className="button button-add" onClick={() => {confirmExport()}} disabled={loading}>
                  {t('buttons.common.export-members')}
                </button>
              </div>
            </div>
          </div>
        </div>
      }
    </>
  )
}
